var _style, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63.4 63.4",
    style: {
      enableBackground: "new 0 0 63.4 63.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#BAB9B7;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 31.9202,
    x2: 63.4,
    y2: 31.9202,
    gradientTransform: "matrix(1 0 0 -1 0 63.6202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A225"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7726"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 31.7,
    cy: 31.7,
    r: 31.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.7,
    cy: 31.7,
    r: 24.3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41,18.2c-0.3-0.1-0.7,0-1,0.1c-5.7,2.3-11.4,4.6-17.1,6.8c-0.2,0.1-0.5,0.1-0.7,0.1c-1.5,0-3,0-4.5,0 c-1.3,0-2.5,0.9-2.9,2.2c-0.1,0.2-0.1,0.4-0.2,0.5c0,1.6,0,3.2,0,4.8c0,0,0,0,0,0.1c0.3,1.4,1.2,2.1,2.6,2.3c0.6,0.1,1.2,0,1.8,0 c0,0.2,0.1,0.3,0.1,0.4c0.4,2.9,0.8,5.8,1.2,8.6c0.1,0.7,0.5,1,1.2,1c1.4,0,2.8,0,4.1,0c0.6,0,1-0.3,1.1-0.8c0.1-0.2,0-0.4,0-0.7 c-0.2-1.9-0.4-3.8-0.6-5.7c-0.1-0.5-0.1-1-0.2-1.6c0.1,0.1,0.3,0.1,0.4,0.1c4.6,1.8,9.2,3.7,13.9,5.5c0.2,0.1,0.5,0.2,0.7,0.1 c0.6-0.1,0.9-0.5,0.9-1.3c0-7.3,0-14.5,0-21.8c0-0.1,0-0.2,0-0.3C41.7,18.6,41.4,18.3,41,18.2z M17.5,33.1c-0.6,0-0.9-0.3-0.9-0.9 c0-1.2,0-2.4,0-3.6c0-0.8,0.4-1.2,1.2-1.2c1.2,0,2.5,0,3.7,0c0,0,0.1,0,0.1,0c0,1.9,0,3.8,0,5.6c0,0,0,0-0.1,0 C20.3,33.1,18.9,33.1,17.5,33.1z M22.2,43.1c-0.4-2.6-0.7-5.2-1.1-7.8c0.8-0.1,1.6-0.1,2.3,0.3c0.1,0.1,0.2,0.2,0.2,0.3 c0.2,1.3,0.3,2.6,0.5,3.9c0.1,0.9,0.2,1.9,0.3,2.8c0,0.2,0,0.3,0,0.5C23.7,43.1,23,43.1,22.2,43.1z M39.5,39.7 c-0.1,0-0.2-0.1-0.3-0.1c-5-2-10.1-4-15.1-6c-0.2-0.1-0.3-0.2-0.3-0.4c0-1.9,0-3.9,0-5.8c0-0.2,0-0.3,0.2-0.4 c5.1-2,10.2-4.1,15.3-6.1c0,0,0.1,0,0.2-0.1C39.5,27.1,39.5,33.4,39.5,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45,27.1c0.3-0.3,0.6-0.5,1-0.8c0.8-0.7,1.7-1.3,2.5-2c0.4-0.3,0.5-0.8,0.3-1.2c-0.2-0.4-0.6-0.7-1.1-0.7 c-0.2,0.1-0.5,0.2-0.7,0.4c-1.2,0.9-2.3,1.8-3.4,2.7c-0.5,0.4-0.6,1.1-0.2,1.6C43.8,27.5,44.4,27.5,45,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.4,37.6c-0.3-0.3-0.6-0.5-1-0.8c-0.8-0.7-1.7-1.4-2.5-2c-0.4-0.3-0.8-0.3-1.2-0.1c-0.4,0.2-0.6,0.5-0.6,0.9 c0,0.4,0.1,0.6,0.4,0.9c1.2,0.9,2.3,1.9,3.5,2.8c0.5,0.4,1.2,0.4,1.6-0.1C49,38.7,48.9,38,48.4,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.3,32.1c0.6,0,1.2,0,1.7,0c0.6,0,1.1,0,1.7,0c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1 c-1.1,0-2.3,0-3.4,0c-0.7,0-1.1,0.4-1.1,1.1C43.2,31.6,43.6,32.1,44.3,32.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/comingSoon.bde2dff117c5e64cd78293cc63fbcac3.svg";
export { ForwardRef as ReactComponent };